import { Modal } from 'semantic-ui-react';
import styled from 'styled-components';

interface StyledModalProps {
  $contentAutoSize?: boolean,
  $minHeight?: string
  $actionContent: boolean
}

export const StyledAbortModal = styled(Modal) <{ $textAlign: string, $minHeight?: string }>`
.header {
	display: flex !important;
	align-items: baseline;
	justify-content: space-between;
	border-bottom: none;
	padding: 15px 10px !important;
	gap: 20px;
}

.content {
	min-height: ${props => props.$minHeight || '100px'};
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
	text-align: ${props => props.$textAlign || 'center'};
}

.header-title {
	font-size: 20px !important;
}

.header-close-icon {
	font-size: 20px !important;
	cursor: pointer;
}

.actions {
	border-top: none;
}
`
export const StyledModal = styled(Modal) <StyledModalProps>`
.header {
	display: flex !important;
	align-items: baseline;
	justify-content: space-between;
	border-bottom: none;
	padding: 15px 10px !important;
}

.content {
	min-height: ${props => props.$contentAutoSize ? 'auto' : props.$minHeight || '200px'};
	position: relative;
}

.header-title {
	font-size: 20px !important;
}

.header-close-icon {
	font-size: 20px !important;
	cursor: pointer;
}

${props => props.$actionContent && ` .actions {
  display: flex;
	justify-content: end;
	align-items: center;
}
`}
`

export const StyledPreviewModal = styled(Modal) <{ height?: any, $heightContent?: string }>`
height: ${props => props.height || '90vh'} !important;
 .content {
  height: ${props => props.$heightContent || '100%'} !important;
	${props => props.$heightContent ? 'padding-top: 0px !important' : ''};
	
	${props => props.$heightContent ? `max-height: ${props.$heightContent} !important` : null}
 }

 .header {
	display: flex !important;
	align-items: baseline;
	justify-content: space-between;
	border-bottom: none;
	padding: 15px 10px !important;
}

.content {
	min-height: 200px;
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
	text-align: center;
}

.header-title {
	font-size: 20px !important;
}

.header-close-icon {
	font-size: 20px !important;
	cursor: pointer;
}
`